export default __webpack_public_path__ + "static/media/car1.e5b638c1.png";